import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider, FieldArray } from "formik";
import {  Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const DecayLoadingAdd = () => {


  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  const [customersList, setCustomersList] = useState([]);  
  const [productLists, setproductLists] = useState([]);
 
  const [permission, setPermission] = useState({});

   let season_id = localStorage.getItem("season_id");

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  
   const formatDate = (date) => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
  
    const [defaultDate, setDefaultDate] = useState(formatDate(new Date()));
  
  const formik = useFormik({
    initialValues: {
      season_id:season_id,
      date: defaultDate,
      product: "",
      quantity: "",
      price: "",
      decay_customer: "",
      driver_plate_number: "",
      note:"",
      currency:"4",
      items:[{
            product: "",
            quantity: "",
            original_quantity: "",
          }]
 
    },
    onSubmit: (values,{ setSubmitting }) => {
      //alert(JSON.stringify(values, null, 2));
      axios
        .post("/decay-sale-loadings/add", values, {
          headers: {
             Authorization: `Bearer ${Authtoken}`,
             Apitoken: Apitoken,
             "Content-Type": "multipart/form-data",
            },
        })
        .then((response) => {
          
          delete backendErrors['error'];
          setSubmitting(false);
         // actions.setSubmitting(false);
         $("#form-submit").text("Add Decay Loading");
          if (response.data.code === 200) {
            toast.success(response.data.message);
         //   actions.resetForm();
            setTimeout(() => {
              window.location.href = "/decay-loading";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    },
  });

 
  useEffect(() => {
        setPermission(FindModuleById(450)); 
console.log(permission);

    
    
    axios
    .post(
      "/products/listing-category-type", 
      {},
      {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }
    )
    .then((response) => {
      if (response.data.code === 200) {
        let products = response.data.data.products;
        let productslisting = products.map((customer, index) => ({
          label: customer.productname,
          value: customer.id,
          key: `address-${index}`,
        }));
        setproductLists(productslisting);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });

    
    axios
    .post(
      "/decay-customers/listing", {},
      {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      }
    )
    .then((response) => {
      if (response.data.code === 200) {
        let suppliers = response.data.data.customers;
        let supplierslist = suppliers.map((cat, index) => ({
          label: cat.name,
          value: cat.id,
          key: `categories-${index}`,
        }));
        setCustomersList(supplierslist);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });

}, []);

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  // const onChangeHandler = (event) => {
  //   console.log(event.target.files[0]);

  //   formik.values.invoice = event.target.files[0];

  // }
  console.log(productLists);
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /> <ToastContainer />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Decay Loading</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/decay-loading">Decay Loadings</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Decay Loading</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Decay Loading Information</h4>
                    {permission && permission.add == 1 && (
                      <FormikProvider value={formik}>
                      <form onSubmit={formik.handleSubmit}>
                     
                        <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                              <label>Date</label>
                             
                              <input
                                type="date"
                                className="form-input form-control"
                                name="date"
                                value={formik.values.date}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                  setDefaultDate(e.target.value);
                                }}
                                onBlur={formik.handleBlur}
                               
                              />
                              <small>
                                {backendErrors.date && (
                                    <span className="form-error mt-1">
                                      {backendErrors.date}
                                    </span>
                                  )}
                              </small>
                            </div>
                       </div>
                       
                       {/* <div className="col-md-6">
                            <div className="form-group status">
                                <label>Select Product</label>
                                <Select
                                className="w-100"
                                value={productLists.find(option => option.value == formik.values.product) || null} // Ensure correct format
                                name="product"
                                 onChange={(selectedOption) => handleSelectChange("product", selectedOption)}
                                onBlur={formik.handleBlur}
                                options={productLists}
                                placeholder="Select"

                                 
                                />
                                <small>
                                  {backendErrors.product && (
                                      <span className="form-error mt-1">
                                        {backendErrors.product}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div> */}
                          
                          
                          <div className="col-md-6">
                            <div className="form-group status">
                                <label>Select Decay Customer</label>
                                <Select
                                className="w-100"
                                value={customersList.find(option => option.value == formik.values.decay_customer) || null} // Ensure correct format
                                name="decay_customer"
                                 onChange={(selectedOption) => handleSelectChange("decay_customer", selectedOption)}
                                onBlur={formik.handleBlur}
                                options={customersList}
                                placeholder="Select"

                                 
                                />
                                <small>
                                  {backendErrors.decay_customer && (
                                      <span className="form-error mt-1">
                                        {backendErrors.decay_customer}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div>

       
                          {/* <div className="col-md-6">
                            <div className="form-group">
                                <label>Quantity</label>
                                <input
                                  type="number"
                                  name="quantity"
                                  value={formik.values.quantity}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                  placeholder="Enter Quantity"
                                />
                                <small>
                                  {backendErrors.quantity && (
                                      <span className="form-error mt-1">
                                        {backendErrors.quantity}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div> */}

                          <div className="col-md-6">
                            <div className="form-group">
                                <label>Driver Plate Number</label>
                                <input
                                  type="text"
                                  name="driver_plate_number"
                                  value={formik.values.driver_plate_number}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                  placeholder="Enter Driver Plate Number"
                                />
                                <small>
                                  {backendErrors.driver_plate_number && (
                                      <span className="form-error mt-1">
                                        {backendErrors.driver_plate_number}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                                <label>Note</label>
                                <input
                                  type="text"
                                  name="note"
                                  value={formik.values.note}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.note && (
                                      <span className="form-error mt-1">
                                        {backendErrors.note}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div>

                        </div>
                         <FieldArray
                              name="items"
                              render={(arrayHelpers) => (
                                <div style={{overflow:"auto2"}}>
                                  <button
                                    className="btn btn-primary mb-3"
                                    type="button"
                                    onClick={() => {
                                      let appendArr =arrayHelpers.form.values.items[0];
                                      let initialArr ={
                                        product: "",
                                        quantity: "",
                                        original_quantity: "",
                                        }
                                        appendArr = (appendArr)?appendArr:initialArr;
                                      arrayHelpers.push(appendArr);
                                    //  setShowTableHeadings(true);
                                      
                                    }}
                                  >
                                    +
                                  </button>
    
                                  <table className="table table-padding">
                                    
                                      <thead>
                                        <tr>
                                          <th >Product</th>
                                          <th>Net Weight</th>
                                          <th>Original Net Weight</th>
                                          <th>#</th>
                                          
                                        
                                        </tr>
                                      </thead>
                                    
                                    <tbody>
                                      {formik.values.items.map(
                                        (friend, index) => (
                                          <tr key={index}>
                                          
                                            <td  >
                                              <div className="form-group status">
                                                <Select
                                              
                                                  name={`items[${index}].product`}
                                                  options={productLists}
                                                  value={productLists.find(option => option.value == formik.values.items[index].product) || null} // Ensure correct format
                                                  onChange={(selectedOption) => {
                                                    formik.setFieldValue(`items[${index}].product`, selectedOption.value); // ✅ Store only value in Formik
                                                    customHandleInput({
                                                      target: {
                                                        name: `items[${index}].product`,
                                                        value: selectedOption.value, // ✅ Ensure only value is passed
                                                      },
                                                    });
                                                  }}
                                                  onBlur={formik.handleBlur}
                                                  placeholder="Select"
                                                  className="w-100"
    
                                                  
                                                />
                                              </div>
                                            </td>
                                          
                                        
                                          
                                          
                                            <td >
                                              <div className="form-group">
                                              
                                                <div className="input-group" >
                                                    <input type="text"  
                                                    name={`items[${index}].quantity`}
                                                    onKeyPress={(event) => {
                                                      // Prevent non-numeric input for keypress
                                                      if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                        event.preventDefault();
                                                      }
                                                    }}
                                                    value={
                                                      formik.values.items[index]
                                                        .quantity
                                                    }
                                                  
                                                    onChange={(e) => {
                                                      formik.handleChange(e);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    className="form-control" placeholder="Net Weight" />
                                                  
                                                </div>
                                              </div>
                                            </td>
                                            <td >
                                              <div className="form-group">
                                              
                                                <div className="input-group" >
                                                    <input type="text"  
                                                    name={`items[${index}].original_quantity`}
                                                    onKeyPress={(event) => {
                                                      // Prevent non-numeric input for keypress
                                                      if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                        event.preventDefault();
                                                      }
                                                    }}
                                                    value={
                                                      formik.values.items[index]
                                                        .original_quantity
                                                    }
                                                  
                                                    onChange={(e) => {
                                                      formik.handleChange(e);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    className="form-control"  placeholder="Original Net Weight" />
                                                    
                                                </div>
                                              </div>
                                            </td>
                                              <td >
                                              <div className="form-group">
                                                <button
                                                  className="btn btn-danger"
                                                  // style={{ marginTop: 30 }}
                                                  type="button"
                                                  onClick={() =>
                                                    arrayHelpers.remove(index)
                                                  }
                                                >
                                                  -
                                                </button>
                                                {index === formik.values.items.length - 1 && (
                                                  <button
                                                      className="btn btn-primary "
                                                      type="button"
                                                      id="add-barcode-button2"
                                                      onClick={async () => {
                                                        let appendArr =arrayHelpers.form.values.items[0];
                                                                let initialArr ={
                                                                  product: "",
                                                                  quantity: "",
                                                                  original_quantity: "",
                                                                }
                                                                appendArr = (appendArr)?appendArr:initialArr;
                                                                arrayHelpers.push(appendArr);
                                                        
                                                      }}
                                                    >
                                                      +
                                                    </button>
                                                )}
                                              </div>
                                            </td> 
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            />
    
    
                      
                        <div className="text-end mt-4">
                          <button className="btn btn-primary" type="submit" id="form-submit"  disabled={formik.isSubmitting}>
                          Add Decay Loading
                          </button>
                        </div>
                      </form>
                    </FormikProvider>
                    )}
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default DecayLoadingAdd;
